import React from "react";
import {
  getEdgeCenter,
  getMarkerEnd,
  getSmoothStepPath,
  Position,
} from "react-flow-renderer";
import { Edge, GlobalStyle } from "./styles";

const CustomEdgeWithoutLabel = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
  style = {
    stroke: "#222",
    strokeWidth: "1px",
    fill: "none",
    strokeDasharray: 0,
  },
  data,
  arrowHeadType,
  markerEndId,
  selected,
}) => {
  if (Math.abs(sourceY - targetY) < 1) {
    sourceY = targetY;
  }

  const center = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 0,
    centerX: center[0],
    centerY: center[1],
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);

  return (
    <>
      <Edge
        id={id}
        style={
          selected === true
            ? {
              ...style,
              strokeWidth: "1px",
              stroke: "#40e5a0",
              fill: "none",
              pointerEvents: "all",
            }
            : data.status === "done"
              ? {
                ...style,
                strokeWidth: "0.1rem",
                stroke: "#339933",
                fill: "none",
                pointerEvents: "all",
              }
              : data.status === 'outscoped' ? {
                ...style,

              }
                : data.criticalPath === true
                  ? { ...style, pointerEvents: "all", stroke: "red" }
                  : { ...style, pointerEvents: "all" }
        }
        d={edgePath}
        markerEnd={markerEnd}
        className="flow_elements_edge"
        data-id={id}
        data-type="normal"
      />

      <path
        id={id}
        style={{
          ...style,
          stroke: "transparent",
          strokeWidth: "0.3rem",
          strokeDasharray: 0,
        }}
        d={edgePath}
        strokeLinejoin="round"
      />
    </>
  );
};

export default CustomEdgeWithoutLabel;
